import { SVGFC } from '@repo/toolkit/types'

const HouseTwoIcon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_12377_41685)">
        <path
          d="M3.02543 11.9594C3.05265 12.0278 3.09977 12.0864 3.16068 12.1276C3.22159 12.1689 3.29349 12.1909 3.36706 12.1909H4.4691V20.2651C4.4691 20.4672 4.63441 20.6325 4.83645 20.6325H18.5826C18.7846 20.6325 18.9499 20.4672 18.9499 20.2651V12.1909H19.8977C19.9712 12.1909 20.0431 12.1689 20.1041 12.1276C20.165 12.0864 20.2121 12.0278 20.2393 11.9594C20.2944 11.8198 20.2613 11.6619 20.1511 11.559L17.8846 9.388V3.73453C17.8846 3.53249 17.7193 3.36719 17.5173 3.36719H15.4932C15.2911 3.36719 15.1258 3.53249 15.1258 3.73453V6.74678L11.9593 3.71249C11.8197 3.57658 11.5956 3.57658 11.4524 3.70882L3.11359 11.5554C3.00706 11.6582 2.97032 11.8198 3.02543 11.9594ZM15.8605 4.10188H17.1499V8.6827L15.8605 7.44841V4.10188ZM11.7022 4.48392L18.983 11.4562H18.5789C18.3769 11.4562 18.2115 11.6215 18.2115 11.8235V19.8978H5.20379V11.8235C5.20379 11.6215 5.03849 11.4562 4.83645 11.4562H4.29277L11.7022 4.48392Z"
          fill={color}
        />
        <g clipPath="url(#clip1_12377_41685)">
          <path
            d="M11.9848 13.9231C12.6396 13.5483 13.087 12.8505 13.087 12.0435C13.087 10.8449 12.1117 9.86963 10.913 9.86963C9.71435 9.86963 8.73912 10.8449 8.73912 12.0435C8.73912 12.8505 9.18651 13.5483 9.8413 13.9231C8.20348 14.3531 7 15.7379 7 17.3792V17.9131C7 18.0331 7.0974 18.1305 7.2174 18.1305C7.3374 18.1305 7.4348 18.0331 7.4348 17.9131V17.3792C7.43478 15.6362 8.99522 14.2175 10.913 14.2175C12.8309 14.2175 14.3913 15.6362 14.3913 17.3792V17.9131C14.3913 18.0331 14.4887 18.1305 14.6087 18.1305C14.7287 18.1305 14.8261 18.0331 14.8261 17.9131V17.3792C14.8261 15.7379 13.6226 14.3527 11.9848 13.9231ZM9.17392 12.0435C9.17392 11.0844 9.95392 10.3044 10.913 10.3044C11.8722 10.3044 12.6522 11.0844 12.6522 12.0435C12.6522 13.0027 11.8722 13.7827 10.913 13.7827C9.95392 13.7827 9.17392 13.0027 9.17392 12.0435Z"
            fill={color}
            stroke={color}
            strokeWidth="0.2"
          />
          <path
            d="M14.4917 13.8786C15.0538 13.5068 15.4261 12.8711 15.4261 12.1488C15.4261 11.0049 14.4959 10.0747 13.352 10.0747C13.2089 10.0747 13.0928 10.1909 13.0928 10.334C13.0928 10.4771 13.2089 10.5932 13.352 10.5932C14.2097 10.5932 14.9076 11.2912 14.9076 12.1488C14.9076 13.0064 14.2097 13.7044 13.352 13.7044C13.2089 13.7044 13.0928 13.8205 13.0928 13.9636C13.0928 14.1067 13.2089 14.2229 13.352 14.2229C15.0678 14.2229 16.4631 15.5124 16.4631 17.098V17.5932C16.4631 17.7363 16.5793 17.8525 16.7224 17.8525C16.8655 17.8525 16.9817 17.7363 16.9817 17.5932V17.098C16.9817 15.5995 15.9363 14.3266 14.4917 13.8786Z"
            fill={color}
            stroke={color}
            strokeWidth="0.2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_12377_41685">
          <rect width="18" height="17.2653" fill={color} transform="translate(3 3.36719)" />
        </clipPath>
        <clipPath id="clip1_12377_41685">
          <rect width="10" height="10" fill={color} transform="translate(7 9)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default HouseTwoIcon
